/**
 * Unified Pro Registration Page - Chauffeur / Partenaire Flotte switcher
 * Route: /register/pro
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../../components/SEO';
import { ArrowLeft, Car, Building2 } from 'lucide-react';
import DriverRegisterPage from '../driver/DriverRegisterPage';
import PartnerRegisterPage from '../partner/PartnerRegisterPage';

export default function ProRegisterPage() {
  const [mode, setMode] = useState('driver'); // 'driver' | 'partner'

  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <SEO title="Devenir chauffeur ou partenaire" description="Rejoignez le réseau Y GO : inscription des chauffeurs VTC indépendants et des partenaires flotte. Recevez des missions qualifiées et développez votre activité." path="/register/pro" />
      <h1 className="sr-only">Inscription chauffeur et partenaire Y GO</h1>
      {/* Top bar with switcher */}
      <div className="sticky top-0 z-50 bg-[#0B0B0B] border-b border-[#2A2A2A]">
        <div className="max-w-md mx-auto px-4 py-3">
          <Link to="/" className="inline-flex items-center gap-2 text-[#C9A24D] hover:text-[#d4af5a] text-sm mb-3" data-testid="back-home">
            <ArrowLeft className="w-4 h-4" /> Retour
          </Link>
          <div className="flex bg-[#1A1A1A] rounded-lg p-1 border border-[#2A2A2A]">
            <button
              onClick={() => setMode('driver')}
              className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium transition-all ${
                mode === 'driver'
                  ? 'bg-[#C9A24D] text-black'
                  : 'text-[#888] hover:text-white'
              }`}
              data-testid="switch-driver"
            >
              <Car className="w-4 h-4" /> Chauffeur
            </button>
            <button
              onClick={() => setMode('partner')}
              className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium transition-all ${
                mode === 'partner'
                  ? 'bg-[#C9A24D] text-black'
                  : 'text-[#888] hover:text-white'
              }`}
              data-testid="switch-partner"
            >
              <Building2 className="w-4 h-4" /> Partenaire Flotte
            </button>
          </div>
        </div>
      </div>

      {/* Content — render the appropriate registration page */}
      {mode === 'driver' ? <DriverRegisterPage embedded /> : <PartnerRegisterPage embedded />}
    </div>
  );
}
